module.exports = __webpack_public_path__ + "media/images/main-visual_sp-bf04ef92a6fc41f2336e30b68667bf78.jpg";